import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/landing/dist/rooftop/@section5/index.js");
